import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useParams } from 'react-router-dom'
import { resolveTriggerListHistoryId } from 'utils/resolveSiteWorkflowIds'
import Container from 'components/Container'
import Row from 'components/Row'
import Col from 'components/Col'
import Tooltip from 'components/Tooltip'
import InfoIcon from 'assets/icons/info-icon'
import AddNewIcon from 'assets/icons/add-new'
import Accordion from 'components/Accordion'
import Modal from 'components/Modal'
import RemoveEcosystemModal from './removeEcosystemModal'
import { SITE_STATUS_DRAFT_ID, SITE_STATUS_NOMINATED_ID } from 'constants/siteStatuses'
import { requestCreateSiteEcoSystem, requestDeleteSiteEcoSystem, requestGetSiteEcosystems } from 'api/ecoSystem'
import EcosystemDocsUploader from '../supportingDocs/ecosystemDocsUploader'
import {
  AssessmentPageNewEcosystemWrapper,
  AssessmentPageSubTittle,
  AssessmentPageSubTittleIconWrapper,
  AssessmentPageSubTittleWrapper,
  AssessmentPageTittle,
  AssessmentPageTittleWrapper
} from '../../style'
import AccordionContent from './accordionContent'
import AccordionHeader from './accordionHeader'
import { EcosystemListTitle, EcosystemListTitleWrapper } from './style'
import { useOverallKbaCriteriaRefresh } from 'flow/siteProposal/pages/assessment/context/OverallKbaCriteriaRefreshContext'

const defaultEcosystem = {
  name: '',
  number: '',
  EcoSystemRedListId: null,
  globalExtent: '',
  extentAtSiteMin: '',
  extentAtSiteBest: '',
  extentAtSiteMax: '',
  assessmentDate: '',
  dataSource: '',
  id: ''
}

const tooltipXOffset = 0
const tooltipYOffset = 16
const sitePropType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  SiteStatusId: PropTypes.number.isRequired,
  reassessmentFlag: PropTypes.bool,
  sitehistoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
})
const EcoSystemsList = ({ site }) => {
  const params = useParams()
  const { refetchCriteria } = useOverallKbaCriteriaRefresh()
  const [ecosystems, setEcosystems] = useState([])
  const [isRemoveEcoSystemModalOpen, setIsRemoveEcoSystemModalOpen] = useState(false)
  const [willBeDeletedEcoSystem, setWillBeDeletedEcoSystem] = useState({})

  function createEcosystem() {
    requestCreateSiteEcoSystem(site.id, params.siteHistoryId).then((data) => {
      setEcosystems((s) => {
        return [...s, data]
      })
      refetchCriteria()
    })
  }

  function getEcosystems() {
    requestGetSiteEcosystems(site.id, resolveTriggerListHistoryId(site, params)).then((data) => {
      setEcosystems([
        ...data.sort((a, b) => {
          if (a.name < b.name) {
            return -1
          }
          if (a.name > b.name) {
            return 1
          }
          return 0
        }).map((item) => {
          return { ...item, assessmentDate: item.assessmentDate }
        })
      ])
      refetchCriteria()
    })
  }

  function deleteEcosystem(ecoSystemId) {
    requestDeleteSiteEcoSystem(ecoSystemId, params.siteHistoryId).then(() => {
      getEcosystems()
      refetchCriteria()
    })
  }

  const openRemoveEcoSystemModal = (ecoSystem) => {
    setIsRemoveEcoSystemModalOpen(true)
    setWillBeDeletedEcoSystem(ecoSystem)
  }

  const updateEcoSystem = (ecoSystem) => {
    if (ecosystems.length === 0) {
      return setEcosystems([ecoSystem])
    }
    setEcosystems((s) => {
      const tmpCopy = [...s]
      const updatedIndex = tmpCopy.findIndex((system) => system.id === ecoSystem.id)
      tmpCopy[updatedIndex] = { ...ecoSystem, assessmentDate: ecoSystem.assessmentDate }
      return tmpCopy
    })
  }

  useEffect(() => {
    getEcosystems()
  }, [])

  if (ecosystems.length === 0 && site.SiteStatusId !== SITE_STATUS_DRAFT_ID) {
    return null
  }

  const approvedEcosystems = ecosystems.filter((item) => item.isApprovedBySecretariat)
  const rejectedEcosystems = ecosystems.filter((item) => !item.isApprovedBySecretariat)

  const newEcosystems = ecosystems.filter((item) => !item.lastReassessmentDate)
  const oldEcosystems = ecosystems.filter((item) => item.lastReassessmentDate)

  return (
    <div>
      <Container>
        <Row>
          <Col md={8} mdOffset={2}>
            <AssessmentPageTittleWrapper>
              <AssessmentPageTittle data-test='legend-ecosystem'>
                <FormattedMessage id='ecosystemData' />
              </AssessmentPageTittle>
              <AssessmentPageSubTittleWrapper
                marginBottom='64px'
                data-test='sub-legend-ecosystem'>
                <AssessmentPageSubTittle>
                  <FormattedMessage id='ecosystemSubTittle' />
                </AssessmentPageSubTittle>
                <Tooltip
                  style={{ zIndex: 1000 }}
                  placement='bottom'
                  trigger={['hover']}
                  align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                  overlay={{ label: 'ecosystemSubTitle', infoTooltip: 'ecosystemSubTitleHint' }}
                >
                  <AssessmentPageSubTittleIconWrapper>
                    <InfoIcon />
                  </AssessmentPageSubTittleIconWrapper>
                </Tooltip>
              </AssessmentPageSubTittleWrapper>
            </AssessmentPageTittleWrapper>
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2} dataTest='ecosystem-group'>
            {ecosystems.length === 0 ? (
              <AccordionContent item={defaultEcosystem} updateEcoSystem={updateEcoSystem} siteId={site.id} defaultPage={true} getEcosystems={getEcosystems} />
            ) : (
              <>
                {site.SiteStatusId === SITE_STATUS_NOMINATED_ID ? (
                  <>
                    {approvedEcosystems.length > 0 && (
                      <>
                        <Row>
                          <Col md={8} mdOffset={2}>
                            <EcosystemListTitleWrapper>
                              <EcosystemListTitle marginTop='0'>
                                <FormattedMessage
                                  id='approvedTriggers' />
                              </EcosystemListTitle>
                            </EcosystemListTitleWrapper>
                          </Col>
                        </Row>
                        <Accordion
                          items={approvedEcosystems}
                              contentProps={{ updateEcoSystem, getEcosystems }}
                          headerProps={{ openRemoveEcoSystemModal, getEcosystems }}
                          contentComponent={AccordionContent}
                          headerComponent={AccordionHeader}
                          initialActive={null}
                        />
                      </>
                    )}
                    {rejectedEcosystems.length > 0 && (
                      <>
                        <Row>
                          <Col md={8} mdOffset={2}>
                            <EcosystemListTitleWrapper>
                              <EcosystemListTitle marginTop='48px'>
                                <FormattedMessage
                                  id='rejectedTriggers' />
                              </EcosystemListTitle>
                            </EcosystemListTitleWrapper>
                          </Col>
                        </Row>
                        <Accordion
                          items={rejectedEcosystems}
                          contentProps={{ updateEcoSystem }}
                          headerProps={{ openRemoveEcoSystemModal, getEcosystems }}
                          contentComponent={AccordionContent}
                          headerComponent={AccordionHeader}
                          initialActive={null}
                        />
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {oldEcosystems.length > 0 && (
                      <>
                        <Row>
                          <Col md={8} mdOffset={2}>
                            <EcosystemListTitleWrapper>
                              <EcosystemListTitle>
                                <FormattedMessage id='existingTriggers' />
                              </EcosystemListTitle>
                            </EcosystemListTitleWrapper>
                          </Col>
                        </Row>
                        <Accordion
                          items={oldEcosystems}
                          contentProps={{ updateEcoSystem, getEcosystems }}
                          headerProps={{ openRemoveEcoSystemModal, getEcosystems, oldTriggers: true }}
                          contentComponent={AccordionContent}
                          headerComponent={AccordionHeader}
                          initialActive={null}
                        />
                      </>
                    )}
                    {newEcosystems.length > 0 && (
                      <>
                        <Row>
                          <Col md={8} mdOffset={2}>
                            <EcosystemListTitleWrapper addMarginTop={true}>
                              <EcosystemListTitle>
                                <FormattedMessage id='newTriggers' />
                              </EcosystemListTitle>
                            </EcosystemListTitleWrapper>
                          </Col>
                        </Row>
                        <Accordion
                          items={newEcosystems}
                            contentProps={{ updateEcoSystem, getEcosystems }}
                          headerProps={{ openRemoveEcoSystemModal, getEcosystems, newTriggers: true }}
                          contentComponent={AccordionContent}
                          headerComponent={AccordionHeader}
                        />
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </Col>
          {site.SiteStatusId === SITE_STATUS_DRAFT_ID && ecosystems.length > 0 && (
            <Col md={8} mdOffset={2}>
              <AssessmentPageNewEcosystemWrapper onClick={createEcosystem} data-test='new-ecosystem-btn'>
                <AddNewIcon />
                <FormattedMessage id='newEcosystem' />
              </AssessmentPageNewEcosystemWrapper>
            </Col>
          )}
        </Row>
      </Container>
      <EcosystemDocsUploader site={site} ecosystems={ecosystems} />
      <Modal
        width={'416px'}
        isOpen={isRemoveEcoSystemModalOpen}
        toggleModal={setIsRemoveEcoSystemModalOpen}
        modalTitleId='removeEcosystem'
        bottomBorder={true}
      >
        <RemoveEcosystemModal
          item={willBeDeletedEcoSystem}
          closeModal={() => {
            setIsRemoveEcoSystemModalOpen(false)
          }}
          confirmRemove={() => {
            deleteEcosystem(willBeDeletedEcoSystem.id)
            setIsRemoveEcoSystemModalOpen(false)
          }}
        />
      </Modal>
    </div>
  )
}

export default EcoSystemsList

EcoSystemsList.propTypes = {
  site: sitePropType.isRequired
}